/** @format */
import { NgModule } from '@angular/core';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { TranslateModule } from '@ngx-translate/core';
import { UIRouterModule } from '@uirouter/angular';
import { LoginErrorComponent } from './login-error.component';
import { loginErrorStates } from './login-error.route';

@NgModule({
    declarations: [LoginErrorComponent],
    imports: [NgxFudisModule, TranslateModule.forChild(), UIRouterModule.forChild({ states: loginErrorStates })],
})
export class LoginErrorModule {}
